import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  units: Yup.string()
    .required('Units is required')
    .max(10, 'Maximum length is 10 characters'),
  scale: Yup.number()
    .required('Scale is required')
    .typeError('Scale must be number'),
  offset: Yup.number()
    .required('Offset is required')
    .typeError('Offset must be number'),
  // .matches(/^\d*\.{1}\d*$/, 'Offset must be a decimal number'),
  description: Yup.string()
    .required('Description is required')
    .max(50, 'Maximum length is 50 characters'),
});
